/**
 * Per-order "revised quotation" intent for PUT /order/update.
 * When enabled, each edit/save or status update bumps …-R0 → R1 → R2… on the server.
 * Stays enabled until the user manually turns it off (not cleared after save).
 */
const KEY_PREFIX = "cogent:orderRevisionBump:v1:";

export function getOrderRevisionBumpIntent(orderId: string): boolean {
  if (!orderId || typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem(KEY_PREFIX + String(orderId)) === "1";
  } catch {
    return false;
  }
}

export function setOrderRevisionBumpIntent(orderId: string, enabled: boolean): void {
  if (!orderId || typeof window === "undefined") return;
  try {
    if (enabled) {
      window.sessionStorage.setItem(KEY_PREFIX + String(orderId), "1");
    } else {
      window.sessionStorage.removeItem(KEY_PREFIX + String(orderId));
    }
  } catch {
    /* private mode / quota */
  }
}
